import { useGetVulnsCountQuery } from "../../hooks/use-get-vulns-count-query";
import {
  AcceptanceStatus,
  VulnerabilityState,
  VulnerabilityTreatment,
  VulnerabilityZeroRiskStatus,
} from "gql/graphql";
import type { ITreatmentAcceptanceActionsDisabled } from "hooks/use-treatment-acceptance";

interface IGetEnabledTreatmentDataProps {
  findingId: string;
  pageSize: number;
}

export const useGetEnabledTreatmentData = ({
  findingId,
  pageSize,
}: IGetEnabledTreatmentDataProps): ITreatmentAcceptanceActionsDisabled => {
  const queryAccepted = useGetVulnsCountQuery({
    filters: {
      treatment: [VulnerabilityTreatment.Accepted],
      treatmentAcceptance: [AcceptanceStatus.Submitted],
    },
    findingId,
    first: pageSize,
  });

  const queryAcceptedUndefined = useGetVulnsCountQuery({
    filters: {
      treatment: [VulnerabilityTreatment.AcceptedUndefined],
      treatmentAcceptance: [AcceptanceStatus.Submitted],
    },
    findingId,
    first: pageSize,
  });

  const queryStateSubmitted = useGetVulnsCountQuery({
    filters: { state: [VulnerabilityState.Submitted] },
    findingId,
    first: pageSize,
  });

  const queryZeroRiskRequested = useGetVulnsCountQuery({
    filters: { zeroRisk: [VulnerabilityZeroRiskStatus.Requested] },
    findingId,
    first: pageSize,
  });

  const result: ITreatmentAcceptanceActionsDisabled = {
    accepted: queryAccepted.total === 0,
    acceptedUndefined: queryAcceptedUndefined.total === 0,
    confirmRejectVulnerability: queryStateSubmitted.total === 0,
    confirmRejectZeroRisk: queryZeroRiskRequested.total === 0,
  };

  return result;
};
